import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringCard } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';

import { TDefaultObjectType } from '@interfaces/common/common';
import { IWithNetworkElementId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { IChangeMonitoringCard } from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CHANGE_MONITORING } from '@constants/queryKeys';

interface IUseQueryChangeMonitoringCardReturn {
	isLoadingChangeMonitoringCard: boolean;
	changeMonitoringCard: TDefaultObjectType<IChangeMonitoringCard>;
}

export const useQueryChangeMonitoringCard = (
	params: Partial<IWithNetworkElementId>,
): IUseQueryChangeMonitoringCardReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CHANGE_MONITORING, params],
		queryFn: extractQueryParams(getChangeMonitoringCard),
		enabled: [!!params.networkElementId],
		...refetchOptions,
	});

	return {
		isLoadingChangeMonitoringCard: isInitialLoading,
		changeMonitoringCard: data || {},
	};
};
